var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"resize",rawName:"v-resize",value:(_vm._resize),expression:"_resize"}],tag:"div",staticClass:"md-container-wrap",style:(_vm._styles)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }